import { Tooltip } from '../overlay/Tooltip'

/**
 * IconButton — square 28px button holding a single icon. Used for row
 * actions (edit, delete), modal close, composer attach. `label` is the
 * accessible name and the (Radix) tooltip text.
 */
export function IconButton({ tone = 'default', label, className = '', children, ...rest }) {
  const cls = [
    'icon-btn',
    tone === 'danger' && 'icon-btn-danger',
    tone === 'ok' && 'icon-btn-ok',
    className
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <Tooltip content={label}>
      <button type="button" className={cls} aria-label={label} {...rest}>
        {children}
      </button>
    </Tooltip>
  )
}
